import {EditPermissions} from "../../../../../../../shared/models";
import {UntypedFormControl, UntypedFormGroup} from "@angular/forms";
import {required} from "../../../../../../../shared/utils";
import {newStepValue} from "../../../../../services/flowBuilder/utils/constants";
import {getEditTypes} from "../../../delegatorUtils";

export interface RegularExpressionData {
    name: string,
    description: string,
    variableName: string,
    functionName: FunctionType,
    yes: string,
    no: string
}

export interface FunctionData {
    pattern: string,
    replace: string,
}

export interface RegularExpressionForms {
    RegularExpressionFrom: UntypedFormGroup,
    FunctionForm: UntypedFormGroup
}

export enum FunctionType {
    MATCH = 'match',
    REPLACE_FIRST = 'replaceFirst',
    REPLACE_ALL = 'replaceAll',
}

export class RegularExpression {

    action: any = {};

    constructor(formData: RegularExpressionData, functionData: FunctionData) {
        this.action = {
            'actionType': 'regularExpression',
        };
        this.setNodeData(formData, functionData);
    }

    static toForm(stepData: { [index: string]: any }, editPermissions: EditPermissions): RegularExpressionForms {
        const {editMenuTextOnly, editFlows} = getEditTypes(editPermissions);
        const formData = this.getFromData(stepData);
        const functionData = this.getFunctionData(stepData);

        return {
            RegularExpressionFrom: this.buildForm(formData, editFlows),
            FunctionForm: this.buildFunctionForm(functionData, formData.functionName, editFlows)
        }
    }


    private static getFromData(stepData: { [index: string]: any }): RegularExpressionData {
        const action = stepData?.action ? stepData?.action : {};
        const actionParams = action?.actionParams ? action?.actionParams : {};
        const result = action?.result ? action?.result : {};


        return {
            name: action.name ? action.name : '',
            description: action.description ? action.description : '',
            variableName: actionParams.variableName ? actionParams.variableName : '',
            functionName: actionParams.function ? actionParams.function : '',
            yes: result.yes ? result.yes : newStepValue,
            no: result.no ? result.no : newStepValue,
        }
    }

    private static buildForm(formData: RegularExpressionData, editFlows: boolean): UntypedFormGroup {
        return new UntypedFormGroup({
            name: new UntypedFormControl({
                value: formData.name,
                disabled: !editFlows
            }, required('Name')),
            description: new UntypedFormControl({
                value: formData.description,
                disabled: !editFlows
            }, required('Description')),
            variableName: new UntypedFormControl({
                value: formData.variableName,
                disabled: !editFlows
            }, required('Variable Name')),
            functionName: new UntypedFormControl({
                value: formData.functionName,
                disabled: !editFlows
            }, required('Function')),
            yes: new UntypedFormControl(formData.yes),
            no: new UntypedFormControl(formData.no),
        });
    }

    static getFunctionData(stepData: { [index: string]: any }): FunctionData {
        const action = stepData?.action ? stepData?.action : {};
        const actionParams = action?.actionParams ? action?.actionParams : {};

        return {
            pattern: actionParams.pattern ? actionParams.pattern : '',
            replace: actionParams.replace ? actionParams.replace : ''
        }
    }

    static buildFunctionForm(functionData: FunctionData, functionType: FunctionType, editFlows: boolean) {
        if (functionType === FunctionType.MATCH) {
            return new UntypedFormGroup({
                pattern: new UntypedFormControl({
                    value: functionData.pattern,
                    disabled: !editFlows
                }, required('Pattern'))
            });
        } else {
            return new UntypedFormGroup({
                pattern: new UntypedFormControl({
                    value: functionData.pattern,
                    disabled: !editFlows
                }, required('Pattern')),
                replace: new UntypedFormControl({
                    value: functionData.replace,
                    disabled: !editFlows
                })
            });
        }
    }

    get nodeData(): {} {
        return {
            action: this.action,
            'type': 'action',
            metadata: {
                nodeVersion: '1.0.0'
            }
        };
    }

    setNodeData(formData: RegularExpressionData, functionData: FunctionData) {
        const {name, variableName, description, functionName, yes, no} = formData;
        const {pattern, replace} = functionData;

        const actionParams = {
            function: functionName,
            variableName,
            pattern
        }

        if (functionName !== 'match') {
            actionParams['replace'] = replace
        }

        const result = {
            yes,
            no
        }

        this.action = {
            ...this.action,
            name,
            description,
            actionParams,
            result
        }
    }
}


// {
//     action: {
//         name: '',
//         description: '',
//         actionType: 'regularExpression',
//         actionParams: {
//             variableName: '',
//             function: '',
//         },
//         result: {
//             yes: newStepValue,
//             no: newStepValue,
//         },
//     },
//     type: 'action',
// }
